var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.error
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [_vm._v(_vm._s(_setup.error))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "p-3 clearfix" }, [
        _c("div", { staticClass: "float-start" }, [
          _c(
            "form",
            {
              staticClass: "d-flex align-items-center",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _setup.loadRows.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _setup.formData.report,
                      expression: "formData.report",
                    },
                  ],
                  staticClass: "form-select me-2",
                  attrs: { name: "report" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _setup.formData,
                        "report",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Select a report…"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_setup.reports, function (report) {
                    return _c(
                      "option",
                      { key: report, domProps: { value: report } },
                      [_vm._v(_vm._s(report))]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _setup.formData.report
                ? [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.formData.startDate,
                          expression: "formData.startDate",
                        },
                      ],
                      staticClass: "form-control me-2",
                      attrs: {
                        name: "start_date",
                        placeholder: "dd/mm/yyyy",
                        size: "12",
                      },
                      domProps: { value: _setup.formData.startDate },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.formData,
                            "startDate",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "form-text me-2" }, [
                      _vm._v("to"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.formData.endDate,
                          expression: "formData.endDate",
                        },
                      ],
                      staticClass: "form-control me-2",
                      attrs: {
                        name: "end_date",
                        placeholder: "dd/mm/yyyy",
                        size: "12",
                      },
                      domProps: { value: _setup.formData.endDate },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.formData,
                            "endDate",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary btn-sm",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _setup.loadRows.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Go")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _setup.rows && _setup.rows.length
          ? _c(
              "div",
              { staticClass: "float-end" },
              [
                _c(
                  _setup.Button,
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _setup.openPrintModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "bi-printer" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Print report"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _setup.downloadCSVData.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "bi-download" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("Download CSV"),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _setup.resultMessage
        ? _c("p", { staticClass: "text-center" }, [
            _vm._v("\n        " + _vm._s(_setup.resultMessage) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.rows && _setup.rows.length
        ? _c("div", { staticClass: "p-2" }, [
            _c(
              "table",
              { staticClass: "table table-condensed table-striped" },
              [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_setup.rows[0], function (value, heading) {
                      return _c(
                        "td",
                        {
                          key: "head-" + heading,
                          on: {
                            click: function ($event) {
                              return _setup.setSortBy(heading)
                            },
                          },
                        },
                        [
                          heading === _setup.sortBy
                            ? _c("span", {
                                class: {
                                  "bi-chevron-up": _setup.sortDir === "asc",
                                  "bi-chevron-down": _setup.sortDir === "desc",
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                    " +
                              _vm._s(heading) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_setup.sortedRows, function (row, rowIndex) {
                    return _c(
                      "tr",
                      { key: "row-" + rowIndex },
                      _vm._l(row, function (value, heading) {
                        return _c(
                          "td",
                          { key: "cell-" + rowIndex + "-" + heading },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(value) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.rows
        ? _c(_setup.PrintReport, {
            ref: "toPrint",
            staticStyle: { display: "none" },
            attrs: {
              "end-timestamp": _setup.endTimestamp,
              heading: _setup.formData.report,
              rows: _setup.sortedRows,
              "start-timestamp": _setup.startTimestamp,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }